import React from 'react';
import { useTranslation } from 'react-i18next';
import { SymbolicTeamFormation } from '../../../../../../domain';
import { PlayerRankContainer, PlayerRankWrapper } from './player-rank.styles';

type PlayerRankProps = {
  className?: string;
  formation: SymbolicTeamFormation;
  rank: number;
};

export const PlayerRank = ({ className, formation, rank }: PlayerRankProps) => {
  const { t } = useTranslation();

  return (
    <PlayerRankWrapper className={className}>
      <PlayerRankContainer className="text footnote">{t(`symbolicTeam.formation_${formation}.rank_${rank}`)}</PlayerRankContainer>
    </PlayerRankWrapper>
  );
};
